import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme) => ({
  rootContainer: {
    padding: '8.5rem 0rem 4.5rem 0rem',
    position: 'relative',
    overflow: 'hidden',
    fontFamily: 'Nunito Sans',
    paddingBottom: '15rem',
    [theme.breakpoints.down('md')]: {
      padding: '5.5rem 0rem 4.5rem 0rem',
      paddingBottom: '14rem',
    },
  },

  contentContainer: {
    textAlign: 'center',
    width: '90%',
  },

  btnContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'start',
    width: 'fit-content !important',
    margin: 'auto',
    marginTop: theme.spacing(8),
  },
  gradientWrapper: {
    width: 'auto',
  },
  recommendBtn: {
    background: 'black',
    width: '200px !important',
    color: 'white',
    '&:hover': {
      background: 'white',
      color: 'black',
    },
  },
}))

export default useStyles
